import { PAGE, COLORS } from '../constants/theme';

export class PageManager {
    constructor(doc) {
        this.doc = doc;
        this.pageNum = 1;
    }

    getPageNum() {
        return this.pageNum;
    }

    setPageNum(num) {
        this.pageNum = num;
        return this.pageNum;
    }

    drawPageFooterNumber() {
        this.doc.setFont('Helvetica', 'bold');
        this.doc.setFontSize(9.5);
        this.doc.setTextColor(0, 0, 0);
        this.doc.text(String(this.pageNum), PAGE.PAGE_NUMBER_X, PAGE.PAGE_NUMBER_Y, { align: 'center' });
    }

    applyStickyPageNumbers() {
        const totalPages = this.doc.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            this.doc.setPage(i);
            this.doc.setFont('Helvetica', 'bold');
            this.doc.setFontSize(9.5);
            this.doc.setTextColor(0, 0, 0);
            this.doc.text(String(i), PAGE.PAGE_NUMBER_X, PAGE.PAGE_NUMBER_Y, { align: 'center' });
        }
    }

    drawTermsCard() {
        this.doc.setFillColor(...COLORS.BG_TERMS_CARD);
        this.doc.setDrawColor(...COLORS.BORDER_TERMS_CARD);
        this.doc.setLineWidth(1);
        this.doc.roundedRect(30, 30, 552, 732, 8, 8, 'FD');
    }

    addPage({ drawTermsCard = false, resetYTo = PAGE.TOP_MARGIN_DEFAULT } = {}) {
        this.drawPageFooterNumber();
        this.doc.addPage();
        this.pageNum++;
        if (drawTermsCard) {
            this.drawTermsCard();
        }
        return resetYTo;
    }
}
